define('views/modules/note/list/note-list-item',[
    // Libs
    'jquery', 'underscore', 'backbone', 'mustache', 'moment', 'bootbox', 'utils', 'toastr',
    // Services
    'services/i18n',
    'services/session',
    'services/mobile-download',
    'services/platform.service',
    // views
    'views/parts/menu/menu-context',
    'views/modules/modal/thumbnail-modal',
    // templates
    'text!templates/modules/note/list/note-list-item.html'
], function(
    // Libs
    $, _, Backbone, Mustache, moment, Bootbox, U, Toastr,
    // services
    i18n,
    Session,
    MobileDownload,
    PlatformService,
    // views
    VMenuContext,
    VThumbnailModal,
    // templates
    TNoteListItem
) {

    var VNoteListItem = Backbone.View.extend({
        template: TNoteListItem,
        events: {
            "click .options-toggle": "showMenuOptions",
            "click .attachment-info a.mobile": "onAttachmentLinkClick",
            "click a": "onLinkClick",
            "click img": "onThumbnailClick"
        },
        regions: {
            menu: ".menu-options"
        },

        initialize: function(opt) {
            opt = opt || {};

            var model = this.model;
            _.extend(this, {
                view: {},
                group: opt.group,
                profile: opt.profile,
                timestamp: moment(model.get('date'))
            });

            this.listenTo(model, {
                'active': this.setActive,
                'change:text': this.render,
                'remove': this.remove
            });

            var attachments = this.model.getAttachments();

            if(attachments && attachments.length != 0) {
                attachments.forEach(function(attachment) {
                    this.downloadAttachment(attachment);
                }, this)
            }
        },

        render: function() {
            var html = Mustache.render(this.template, Mustache.getContext(_.extend(this.model.toJSON(), {
                date: moment(this.model.get('date')).format('DD-MM-YYYY'),
                isMobile: PlatformService.isMobile()
            })));
            this.$el.empty().append(html);

            this.generateZones();

            if (this.view.menu) {
                this.assign(this.view.menu, this.zone.$menu);
            }

            return this;
        },

        showMenuOptions: function(e) {
            e.preventDefault();
            if (!this.view.menu) {
                this.view.menu = new VMenuContext({
                    context: this,
                    onClick: this.onActionClick,
                    collection: new Backbone.Collection([
                        { caption: "Edit", icon: "sl-icon-pencil", callback: this.onEditAction },
                        { caption: "Delete", icon: "sl-icon-trash", callback: this.onDeleteAction }
                    ]),
                });
                this.assign(this.view.menu, this.zone.$menu);
            }
            this.view.menu.toggle();
        },

        downloadAttachment: function(attachment) {
            var noteItem = this;

            this.createAjaxTransport();

            var options = this.transportOptions = {
                url: attachment.url,
                method: "get",
                dataType: "binary",
                // processData: false,
            };

            return $.ajax(options).then(function(data) {
                var binaryData = [];
                binaryData.push(data);

                var blob = new Blob(binaryData, { type: "image/jpeg" });
                var urlCreator = window.URL || window.webkitURL;
                var imageUrl = urlCreator.createObjectURL(blob);

                attachment.image = imageUrl;
                attachment.url = imageUrl;
                noteItem.render();
            });
        },

        createAjaxTransport: function() {
            var noteItem = this;

            $.ajaxTransport("+binary", function(options, originalOptions, jqXHR) {
                // check for conditions and support for blob / arraybuffer response type
                if (window.FormData &&
                    options.dataType && options.dataType === 'binary' ||
                    options.data && window.ArrayBuffer && options.data instanceof ArrayBuffer ||
                    window.Blob && options.data instanceof Blob) {
                    return {
                        // create new XMLHttpRequest
                        context: noteItem,
                        send: noteItem.sendAjaxRequest,
                        abort: function() {
                            jqXHR.abort();
                        }
                    };
                }
            });
        },

        sendAjaxRequest: function(headers, callback) {
            var transportOptions = this.context.transportOptions;

            // setup all variables
            var xhr = new XMLHttpRequest(),
                url = transportOptions.url,
                type = transportOptions.method,
                async = transportOptions.async || true,
                // blob or arraybuffer. Default is blob
                dataType = transportOptions.responseType || "blob",
                data = transportOptions.data || null,
                username = transportOptions.username || null,
                password = transportOptions.password || null;

            xhr.addEventListener('load', function() {
                var data = {};
                data[transportOptions.dataType] = xhr.response;
                // make callback and send data
                callback(xhr.status, xhr.statusText, data, xhr.getAllResponseHeaders());
            });

            xhr.open(type, url, async, username, password);

            // setup custom headers
            for (var i in headers) {
                if (headers.hasOwnProperty(i)) {
                    xhr.setRequestHeader(i, headers[i]);
                }
            }

            xhr.responseType = dataType;
            xhr.send(data);
        },
        /////////////
        // actions //
        /////////////
        onActionClick: function(e, item, menu) {
            e.preventDefault();
        },
        onEditAction: function() {
            this.model.trigger("note:edit", this.model);
        },
        onDeleteAction: function() {
            Bootbox.confirm({
                title: i18n.t('note:Delete a note'),
                message: i18n.t('messages:message-delete-note'),
                callback: this.onDelete,
                context: this,
            });
        },

        ////////////
        // events //
        ////////////
        onDelete: function(result) {
            var model = this.model;
            if (result) {
                model.setGroup(this.group.id);
                model.setUser(this.profile.id);
                model.destroy();
            }
        },

        saveAttachment: function() {
            var attachment = this.model.get('attachment');
            MobileDownload.download(attachment.display_url, attachment.name, attachment.mimeType);
        },

        onAttachmentLinkClick: function(e) {
            e.preventDefault();
            e.stopPropagation();
            // Capacitor Filesystem plugin handles permissions automatically
            this.saveAttachment();
        },

        onLinkClick: function(e) {
            // Open in system browser on native platforms
            if (window.Capacitor && window.Capacitor.isNativePlatform()) {
                e.preventDefault();
                window.open(encodeURI(e.target.href), '_system');
            }
            return true;
        },

        onThumbnailClick: function(e) {
            // Find correct attachment based on it's name
            var attachment = this.model.get("attachment").find(function(att) {
                return att.name == e.currentTarget.name;
            }, this);

            if(!attachment) {
                return;
            }

            (new VThumbnailModal(attachment.display_url, attachment.name)).render();
        }

    });

    return VNoteListItem;
});

